let humanListenersAttached = false;

/**
 * Marks the current page's honeypot field once any human interaction is seen.
 * Spambots often lack mouse/keyboard support, so a missing mark flags a bot.
 *
 * The `document` listeners attach at most once and re-query `#hiwm` at event
 * time, so this survives a Turbo navigation without stacking listeners.
 *
 * @returns {void}
 */
function watchForHumanInput() {
  if (humanListenersAttached) return;
  humanListenersAttached = true;

  const mark = () => {
    const field = document.querySelector('#hiwm');
    if (field && field.value !== 'yes')
      field.value = 'yes';
  };

  document.addEventListener('mousemove', mark);
  document.addEventListener('keyup', (event) => {
    if (event.key === 'Tab')
      mark();
  });
}

class Signup {
  /**
   * Hides the fake username field from humans on the current page. A spambot
   * fills every field, so a filled value flags a bot.
   *
   * @returns {void}
   */
  static hideUsername() {
    const honeypot = document.querySelector('.usnft');
    if (honeypot)
      honeypot.style.display = 'none';
  }

  /**
   * Wires the signup form on the current page, if present.
   *
   * @returns {void}
   */
  static ready() {
    if (!document.querySelector('form#new_user')) return;

    Signup.hideUsername();
    watchForHumanInput();
  }
}

export default Signup;
